import { wt_rekruttering, wt_tilbud } from "../constants/WebtempTyper";
import { getRedirectProps } from "./redirect";
import { CVPSearchParams } from "./wsQueryStringStore";

export const getJobRedirectProps = (irel: number, trel: number) => {
  const id_rekruttering = trel === wt_rekruttering ? irel?.toString() : null;
  const id_tilbud = trel === wt_tilbud ? irel?.toString() : null;

  return getRedirectProps("job", {
    mergeQs: {
      [CVPSearchParams.cvpr]: id_rekruttering,
      [CVPSearchParams.cvpt]: id_tilbud,
    },
  });
};

export const getApplyRedirectProps = (irel: number, trel: number) => {
  const id_rekruttering = trel === wt_rekruttering ? irel?.toString() : null;
  const id_tilbud = trel === wt_tilbud ? irel?.toString() : null;

  return getRedirectProps("apply", {
    mergeQs: {
      [CVPSearchParams.cvpr]: id_rekruttering,
      [CVPSearchParams.cvpt]: id_tilbud,
    },
  });
};

export const getApplyManuallyRedirectProps = (
  irel: number,
  trel: number,
  state?: any
) => {
  const id_rekruttering = trel === wt_rekruttering ? irel?.toString() : null;
  const id_tilbud = trel === wt_tilbud ? irel?.toString() : null;

  return getRedirectProps("apply-manually", {
    mergeQs: {
      [CVPSearchParams.cvpr]: id_rekruttering,
      [CVPSearchParams.cvpt]: id_tilbud,
    },
    state,
  });
};
